import { SearchHistoryCard } from "../../../components/SearchHistoryCard";
import { SearchHistory } from "../../../store/LocalDbStore";

type RenderItemProps = {
  idx: number;
  item: SearchHistory;
  context: any;
};

export const RenderItem = ({ idx, item, context }: RenderItemProps) => {
  const { onSearchAgain } = context;
  return (
    <div key={idx} style={{ paddingRight: "5px", paddingLeft: "1px" }}>
      <SearchHistoryCard history={item} onChangeSearch={onSearchAgain} />
    </div>
  );
};
